<template>
  <!-- boardId : 675-->
  <monitoring />
</template>

<script>

import Monitoring from "./monitoring.vue";
export default {
  components: {Monitoring},
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
}
</script>

<style scoped>

</style>
